import { Paper } from '@mui/material';

export default function GlobalPaper({ children, sx, ...props }) {
    return (
        <Paper sx={{ borderRadius: 1, padding: 3, mb:2, ...sx }}  {...props}>
            {children}
        </Paper>
    );
}
